<yc-modal *ngIf="formGroup || !canUpdateStatus"
  [modalHeader]="modalHeader"
  [modalSubHeader]="modalSubheader"
  [primaryButtonText]="!canUpdateStatus ?
    ('common:textClose' | ycI18n: 'Close') :
    primaryButtonText"
  [cancelButtonText]="!canUpdateStatus ? '' : 'common:btnCancel' | ycI18n: 'Cancel'"
  [primaryDisabled]="(!canUpdateStatus ? false : formGroup.invalid) || submitting"
  (onCancel)="closeModal.emit()"
  (onPrimaryClick)="onPrimaryClick()">

  <ng-container *ngIf="!canUpdateStatus">
    <yc-i18n
      key="common:textCannotCancelAppHasAwards"
      defaultValue="Application cannot be canceled because it already has awards.">
    </yc-i18n>
  </ng-container>

  
  <ng-container *ngIf="canUpdateStatus" 
    [formGroup]="formGroup">
    <ng-container *ngIf="!isManager">
      <yc-i18n *ngIf="!isNomination"
        [key]="'common:textApplicantCancelationText'"
        [context]="{
          programName: programName
        }"
        [defaultValue]="'Once canceled you will be unable to make any change to your application. If you wish to open your application after canceling, you will need to contact an administrator of __programName__. Please provide a reason and comment for your cancelation below. Once confirmed, an email notifying application cancelation will be sent to all applicants on the application.'">
      </yc-i18n>
      <yc-i18n *ngIf="isNomination"
        [key]="'common:textNominatorCancelationText'"
        [context]="{
          programName: programName
        }"
        [defaultValue]="'Once canceled you will be unable to make any changes to your nomination. If an application was created from this nomination, it will also be canceled. If you wish to open your nomination after canceling, you will need to contact an administrator of __programName__. Please provide a reason and comment for your cancelation below. Once confirmed, an email notifying application cancelation will be sent to all nominators on the nomination.'">
      </yc-i18n>
    </ng-container>
    <ng-container *ngIf="isManager">
      <yc-i18n *ngIf="!isNomination"
        [key]="'common:textManagerCancelationText'"
        [defaultValue]="'Canceling the application will prevent it from proceeding through the workflow. Canceling will have the following impact:'">
      </yc-i18n>
      <yc-i18n *ngIf="isNomination"
        [key]="'common:textManagerCancelationTextNomination'"
        [defaultValue]="'Canceling the nomination will prevent it from proceeding through the workflow. Canceling will have the following impact:'">
      </yc-i18n>
      <ul class="mt-3">
        <li *ngIf="!currentlyDraftStatus">
          <yc-i18n
            [key]="'common:textNoWorkflowActionsAvailable'"
            [defaultValue]="'No workflow level actions (approve, award, create payments, etc.) will be available'">
          </yc-i18n>          
        </li>
        <li>
          <yc-i18n
            [key]="'common:textNoScheduledEmailsSent'"
            [defaultValue]="'No scheduled emails will be sent'">
          </yc-i18n>          
        </li>
        <li *ngIf="!currentlyDraftStatus">
          <yc-i18n
            [key]="'common:textNoFormDueDatesInEffect'"
            [defaultValue]="'No form due dates will be in effect'">
          </yc-i18n>          
        </li>
        <li>
          <yc-i18n
            [key]="'common:textFormsCannotBeEditedOrSubmitted'"
            [defaultValue]="'Forms cannot be edited or submitted'">
          </yc-i18n>          
        </li>
        <li *ngIf="!currentlyDraftStatus">
          <yc-i18n *ngIf="!isNomination"
            [key]="'common:textApplicationWillBeAutomaticallyRoutedOut'"
            [defaultValue]="'The application will be automatically routed out of current workflow into another one if routing rule set up based on a status of \'canceled\''">
          </yc-i18n>     
          <yc-i18n *ngIf="isNomination"
            [key]="'common:textNominationWillBeAutomaticallyRoutedOut'"
            [defaultValue]="'The nomination will be automatically routed out of current workflow into another one if routing rule set up based on a status of \'canceled\''">
          </yc-i18n>      
        </li>
        <li *ngIf="!currentlyDraftStatus">
          <yc-i18n
            [key]="'common:textCanBeManuallyRouted'"
            [defaultValue]="'Can be manually routed to another WFL by reviewer'">
          </yc-i18n>          
        </li>
        <li>
          <yc-i18n *ngIf="!isNomination"
            [key]="'common:textApplicationStatsNotShownInInsights'"
            [defaultValue]="'Stats for the application will not show in insights'">
          </yc-i18n>
          <yc-i18n *ngIf="isNomination"
            [key]="'common:textNominationStatsNotShownInInsights'"
            [defaultValue]="'Stats for the nomination will not show in insights'">
          </yc-i18n>        
        </li>
      </ul>
    </ng-container>
    <!-- FORM -->
    <!-- REASON -->
    <div class="mt-3">
      <yc-typeahead-select
        [items]="reasonSelectOptions"
        [label]="'common:textReasonForCancel' | ycI18n: 'Reason for cancel'"
        name="reason">
      </yc-typeahead-select>
    </div>
    <!-- COMMENT -->
    <div class="mt-3">
      <yc-textarea
        [label]="'common:labelComment' | ycI18n: 'Comment'"
        [maxLength]="2000"
        name="comment">
      </yc-textarea>
    </div>
    <!-- FOR GRANT MANAGER -->
    <ng-container *ngIf="isManager && emailActive">
      <!-- NOTIFY -->
      <div class="mt-3">
        <yc-checkbox
          name="notifyApplicant"
          [optionLabel]="'common:textNotifyApplicantOfCancelation' | ycI18n: 'Send email to notify applicant of cancelation'">
        </yc-checkbox>
      </div>
      <gc-select-email-template
        [programId]="programId"
        [notifyApplicant]="formGroup.value.notifyApplicant"
        [emailType]="emailType"
        [allowCCandBCC]="false"
        [applicationIds]="[applicationId]"
        [formGroup]="formGroup">
      </gc-select-email-template>

    </ng-container>
  </ng-container>
</yc-modal>